// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resultDialog img[data-v-08b39c4a]{width:3.64583vw;height:3.64583vw}.resultDialog .tip[data-v-08b39c4a]{display:flex;flex-direction:column;align-items:center;padding:.52083vw 0 1.5625vw 0}.resultDialog .tip div[data-v-08b39c4a]{line-height:2.60417vw;color:#b9b9b9}.resultDialog .tip .title[data-v-08b39c4a]{font-size:1.25vw;margin-top:1.04167vw;color:#fff}.resultDialog .tip .el-button[data-v-08b39c4a]{color:#b9b9b9}", ""]);
// Exports
module.exports = exports;
